import { createTheme } from '@mui/material/styles';
import { THEME_COLORS } from '@/constants';

// Create a custom theme with proper typography and spacing
const theme = createTheme({
  palette: {
    primary: {
      main: THEME_COLORS.PRIMARY,
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: THEME_COLORS.SECONDARY,
      light: '#6d6d6d',
      dark: '#212121',
    },
    success: {
      main: THEME_COLORS.SUCCESS,
    },
    error: {
      main: THEME_COLORS.ERROR,
    },
    warning: {
      main: THEME_COLORS.WARNING,
    },
    info: {
      main: THEME_COLORS.INFO,
    },
    background: {
      default: THEME_COLORS.BACKGROUND,
      paper: THEME_COLORS.SURFACE,
    },
    text: {
      primary: THEME_COLORS.TEXT_PRIMARY,
      secondary: THEME_COLORS.TEXT_SECONDARY,
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Oxygen',
      'Ubuntu',
      'Cantarell',
      '"Fira Sans"',
      '"Droid Sans"',
      '"Helvetica Neue"',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.125rem',
      fontWeight: 300,
      lineHeight: 1.167,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.6,
    },
    h4: {
      fontSize: '1.125rem',
      fontWeight: 500,
      lineHeight: 1.235,
    },
    h5: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.6,
    },
    h6: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.6,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.43,
    },
    button: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.75,
      textTransform: 'none',
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          marginBottom: '16px',
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            '& .MuiOutlinedInput-input': {
              padding: '16.5px 14px',
              fontSize: '16px',
              lineHeight: '1.4375em',
            },
          },
          '& .MuiInputLabel-root': {
            fontSize: '16px',
            lineHeight: '1.4375em',
            transform: 'translate(14px, 16px) scale(1)',
            '&.MuiInputLabel-shrink': {
              transform: 'translate(14px, -9px) scale(0.75)',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '0.875rem',
          fontWeight: 500,
          lineHeight: 1.75,
          borderRadius: 8,
          padding: '10px 24px',
        },
        sizeLarge: {
          fontSize: '0.9375rem',
          padding: '10px 22px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          marginRight: 0,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '9px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Roboto, sans-serif',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
  },
});

export default theme;
